import { useContext } from 'react'
import { Checkbox, TableCell, TableHead, TableRow, TableSortLabel } from '@material-ui/core'

import ContentManagementContext, { SortBy } from '../../../ContentManagementProvider/Context'

type ContentTableHeaderProps = {
  viewOnly?: boolean
  allContentSelected: boolean
  someContentSelected: boolean
  onSelectAllContent: (checked: boolean) => void
}
const ContentTableHeader = ({
  viewOnly,
  allContentSelected,
  someContentSelected,
  onSelectAllContent,
}: ContentTableHeaderProps) => {
  const { orderBy, order, handleTableSorting } = useContext(ContentManagementContext)

  const headCells = [
    { id: 'title', label: 'Title', sortKey: 'title' },
    { id: 'status', label: 'Status', sortKey: 'status' },
    { id: 'contentType', label: 'Type', sortKey: 'type' },
    { id: 'tags', label: 'Topics' },
    { id: 'lastUpdated', label: 'Last Updated', sortKey: 'updated' },
  ]

  const handleSelectAllContent = (event: React.MouseEvent<HTMLButtonElement>) => {
    const { target } = event as unknown as { target: HTMLInputElement }
    // If some content is selected, then unselect all content, otherwise select all content
    onSelectAllContent(someContentSelected ? false : target.checked)
  }

  return (
    <TableHead>
      <TableRow>
        {!viewOnly && (
          <TableCell padding="checkbox">
            <Checkbox
              inputProps={{ 'aria-label': 'Select All Content' }}
              color="primary"
              indeterminate={someContentSelected && !allContentSelected}
              onClick={handleSelectAllContent}
              checked={allContentSelected}
            />
          </TableCell>
        )}
        {headCells.map((headCell) => (
          <TableCell key={headCell.id}>
            {headCell.sortKey ? (
              <TableSortLabel
                active={orderBy === headCell.sortKey}
                direction={orderBy === headCell.sortKey ? order : 'asc'}
                onClick={() => {
                  const isAsc = orderBy === headCell.sortKey && order === 'asc'
                  handleTableSorting(headCell.sortKey! as SortBy, isAsc ? 'desc' : 'asc')
                }}
              >
                {headCell.label}
              </TableSortLabel>
            ) : (
              headCell.label
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}

export default ContentTableHeader
